import { createStyles, makeStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    tableContainer: {
      minHeight: '100px',
      maxHeight: '350px',
      [theme.breakpoints.down('sm')]: {
        height: '370px'
      }
    },
    headerBlock: {
      justifyContent: 'space-between',
      background: 'transparent',
      padding: '24px 40px',
      display: 'flex',
      height: '100px',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        height: 'auto'
      },
      [theme.breakpoints.only('sm')]: {
        alignItems: 'baseline',
        gap: '24px',
        padding: '24px 30px'
      },
      [theme.breakpoints.only('xs')]: {
        gap: '16px',
        justifyContent: 'center',
        padding: '16px 24px'
      }
    },
    heading: {
      fontSize: '40px',
      fontWeight: 600,
      lineHeight: '1',
      [theme.breakpoints.only('xs')]: {
        fontSize: '32px'
      }
    },
    formLabel: {
      margin: '0px 0px 10px',
      fontSize: '16px',
      fontWeight: 'bold',
      paddingLeft: '16px'
    },
    formBox: {
      background: 'transparent',
      minWidth: '100%',
      paddingBottom: '32px',
      '& > * > *': {
        [theme.breakpoints.down('xs')]: {
          minWidth: '240px',
          width: '245px'
        }
      }
    },
    formInnerContainer: {
      display: 'flex',
      flexDirection: 'column',
      background: 'transparent',
      flex: 1,
      minHeight: 0
    },
    outerBox: {
      flex: 'none',
      background: 'transparent'
    },
    venueTaxDetailsHeaders: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600,
      cursor: 'pointer'
    },
    buttonGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '1rem',
      marginTop: '2rem',
      flex: 'none'
    },
    tableHeaders: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600,
      cursor: 'pointer'
    }
  })
);
